<template>
    <div class="view">
        <div class="uoloadImgBox">
            <van-uploader :after-read="(file) => afterRead(file, 1)">
                <van-image class="carImg" :src="driverInfo.vehicle_front || defaultImg1" radius="5">
                        <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
            </van-uploader>
            <van-uploader :after-read="(file) => afterRead(file, 2)">
                <van-image class="carImg" :src="driverInfo.pic || defaultImg2" radius="5">
                        <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
            </van-uploader>
            <div class="infoBox">
                <div class="infoLi">
                    <div class="label">车牌号</div>
                    <div :class="['value', {'placeholder': !driverInfo.license}]">{{ driverInfo.license || '上传行驶证识别' }}</div>
                </div>
                <div class="infoLi" @click="openCarType">
                    <div class="label">车辆类型</div>
                    <div :class="['value', {'placeholder': !driverInfo.mode}]">{{ carModelName || '请选择车辆类型' }}</div>
                    <van-icon name="arrow" />
                </div>
            </div>
        </div>
        <div class="uoloadImgBox" v-if="false">
            <div class="insurance">
                <div class="insuranceName">交强险（必传）</div>
                <van-uploader :after-read="(file) => afterRead(file, 3)">
                    <van-image class="insuranceImg" :src="driverInfo.insurance_url || defaultImg3" radius="5">
                            <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                    </van-image>
                </van-uploader>
            </div>
            <div class="insurance">
                <div class="insuranceName">商业险（必传）</div>
                <van-uploader :after-read="(file) => afterRead(file, 4)">
                    <van-image class="insuranceImg" :src="driverInfo.commercial_url || defaultImg4" radius="5">
                            <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                    </van-image>
                </van-uploader>
            </div>
            <div class="insurance">
                <div class="insuranceName">拖挂险（必传）</div>
                <van-uploader :after-read="(file) => afterRead(file, 5)">
                    <van-image class="insuranceImg" :src="driverInfo.trailer_url || defaultImg5" radius="5">
                            <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                    </van-image>
                </van-uploader>
            </div>
        </div>
        <div class="footer">
            <div class="btn" @click="submitAuth">提交认证</div>
        </div>
         <!-- 车辆类型 -->
        <van-popup v-model="cartypePicker" round position="bottom" safe-area-inset-bottom>
            <van-picker 
                show-toolbar 
                title="车辆类型" 
                :columns="cartypeData"
                value-key="name"
                @confirm='confirmCartype'
                @cancel='cartypePicker = false'/>
        </van-popup>
    </div>
</template>

<script>
import Compressor from 'compressorjs';
import { driverDetail, ocrVehicle, ocrLicense, ocrInsurance, carmodelParams, vehicleIdentity } from '@/apis/join'
export default {
    data(){
        return {
            driverId: '',
            defaultImg1: 'https://h5.zykjsz.com/images/merchantApp/xingshizheng.png',
            defaultImg2: 'https://h5.zykjsz.com/images/merchantApp/cheshen.png',
            defaultImg3: 'https://h5.zykjsz.com/images/merchantApp/insuranceImg1.png',
            defaultImg4: 'https://h5.zykjsz.com/images/merchantApp/insuranceImg2.png',
            defaultImg5: 'https://h5.zykjsz.com/images/merchantApp/insuranceImg3.png',
            cartypePicker: false,
            cartypeData: [],
            carModelName: '',
            driverInfo: {
                license: '',                //车牌号
                mode: '',                    //车辆类型
                pic: '',                    //车身照
                pic_key: '',                    //车辆照ocr识别key
                vehicle_front: '',          //行驶证照片
                vehicle_key: '',          //行驶证照片ocr识别key
                insurance_url: '',           //交强险照片
                insurance_key: '',
                commercial_url: '',           //商业险照片
                commercial_key: '',
                trailer_url: '',           //拖挂险照片
                trailer_no: '',
                trailer_time: '',
                trailer_company: '',
            },
        }
    },
    mounted(){
        let e = this.$route.query.e
        if(e){
            let info = this.$xorEncrypt(e)
            info = JSON.parse(info)
            let nowTime = new Date().getTime();
            if(nowTime - info.time > 12*60*60*1000){
                this.toRegister(info.company)
            }else{
                this.driverId = info.id
                this.getCarmodel()
                this.getDetail()
            }
        }else{
            this.toRegister()
        }
    },
    methods: {
        // 回注册页
        toRegister(s){
            this.$notify({
                type: 'danger',
                message: '验证信息过期，请重新获取验证码！'
            })
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('driverId');
            this.$router.replace(`/register?s=${s}`);
        },
        // 获取车型参数
        getCarmodel(){
            carmodelParams().then((res)=>{
                let data = res.data.data
                this.cartypeData = data
                for(let i=0; i<data.length; i++){
                    if(this.driverInfo.mode && this.driverInfo.mode == data[i].no){
                        this.carModelName = data[i].name
                        console.log(this.carModelName)
                        break
                    }
                }
            })
        },
        // 师傅详情
        getDetail(){
            let params = {
                id: this.driverId
            }
            driverDetail(params).then((res)=>{
                console.log(res, '师傅详情')
                let info = res.data.data
                this.driverInfo.vehicle_front = info.vehicle_front
                this.driverInfo.pic = info.pic
                this.driverInfo.license = info.license
                this.driverInfo.mode = info.mode
                this.driverInfo.insurance_url = info.insurance_url
                this.driverInfo.commercial_url = info.commercial_url
                this.driverInfo.trailer_url = info.trailer_url
                this.getCarmodel()
            })
        },
        openCarType(){
            this.cartypePicker = true
        },
        confirmCartype(e){
            this.driverInfo.mode = e.no
            this.carModelName = e.name
            this.cartypePicker = false
        },
        // 上传文件
        afterRead(file, t){
            let that = this
            new Compressor(file.file, {
                quality: 0.2,
                success(result) {
                    // t  1:行驶证  2：车牌  3：交强保单   4：商业保单   5：拖挂保单
                    that.$toast.loading({
                        message: '自动识别中...',
                        forbidClick: true,
                        overlay: true,
                        duration: 0,
                        loadingType: 'spinner',
                    });
                    let formData = new FormData();
                    formData.append('file', result)
                    if(t == 1){
                        ocrVehicle(formData).then((res)=>{
                            console.log('行驶证识别', res)
                            let data = res.data
                            that.$notify({
                                type: data.code == 1 ? 'success' : 'danger',
                                message: data.code == 1 ? '识别成功' : data.info
                            })
                            if(data.code == 1){
                                let info = data.data
                                that.driverInfo.vehicle_front = info.url
                                that.driverInfo.vehicle_key = info.key
                                that.driverInfo.license = info.data.number;
                            }
                            that.$toast.clear();
                        }).catch((err)=>{
                            that.$toast.clear();
                        })
                    }else if(t == 2){
                        ocrLicense(formData).then((res)=>{
                            console.log('车牌识别', res)
                            let data = res.data
                            that.$notify({
                                type: data.code == 1 ? 'success' : 'danger',
                                message: data.code == 1 ? '识别成功' : data.info
                            })
                            if(data.code == 1){
                                let info = data.data
                                that.driverInfo.pic = info.url
                                that.driverInfo.pic_key = info.key
                            }
                            that.$toast.clear();
                        }).catch((err)=>{
                            that.$toast.clear();
                        })
                    }else if(t == 3 || t == 4 || t == 5){
                        ocrInsurance(formData).then((res)=>{
                            console.log('保单识别', res)
                            let data = res.data
                            that.$notify({
                                type: data.code == 1 ? 'success' : 'danger',
                                message: data.code == 1 ? '识别成功' : data.info
                            })
                            that.$toast.clear();
                        }).catch((err)=>{
                            that.$toast.clear();
                        })
                    }
                    console.log(that.driverInfo)
                }
            })
        },
        submitAuth(){
            let info = this.driverInfo
            if(!info.pic_key){
                this.$notify({
                    type: 'danger',
                    message: '请重新上传车头照！'
                })
                return
            }
            if(!info.vehicle_key){
                this.$notify({
                    type: 'danger',
                    message: '请重新上传行驶证照片！'
                })
                return
            }
            if(!info.mode){
                this.$notify({
                    type: 'danger',
                    message: '请选择车辆类型！'
                })
                return
            }
            this.$toast.loading({
                message: '提交认证中...',
                forbidClick: true,
                overlay: true,
                duration: 0,
                loadingType: 'spinner',
            });
            let data = {
                license: info.license,
                mode: info.mode,
                pic: info.pic,
                pic_key: info.pic_key,
                vehicle_front: info.vehicle_front,
                vehicle_key: info.vehicle_key
            }
            vehicleIdentity(data).then((res)=>{
                console.log('车辆认证', res)
                let data = res.data
                if(data.code == 4000){
                    this.$toast.clear();
                    this.$notify({
                        type: 'danger',
                        message: '登录异常，请重新获取验证码登录！'
                    })
                    this.$router.go(-1)
                    return
                }
                this.$notify({
                    type: data.code == 1 ? 'success' : 'danger',
                    message: data.code == 1 ? '认证成功' : data.info || data.data
                })
                if(data.code == 1){
                    this.$router.go(-1)
                }
                this.$toast.clear();
            }).catch((err)=>{
                this.$toast.clear();
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .view{
        min-height: 100vh;
        font-size: 14px;
        color: #333333;
        background: #F7F7F7;
        .uoloadImgBox{
            width: 100%;
            background: #FFFFFF;
            padding: 12px 12px 0;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 12px;
            .carImg{
                width: 170px;
                height: 109px;
                margin-bottom: 10px;
            }
            .insuranceName{
                font-weight: bold;
                font-size: 13px;
                margin-bottom: 10px;
            }
            .insuranceImg{
                width: 109px;
                height: 156px;
                border-radius: 3px;
            }
            .infoBox{
                width: 100%;
                .infoLi{
                    height: 40px;
                    display: flex;
                    align-items: center;
                    .label{
                        width: 112px;
                        color: #666;
                    }
                    .value{
                        flex: 1;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .placeholder{
                        color: #999;
                    }
                }
            }
        }
        .footer{
            width: 375px;
            background: #FFFFFF;
            padding: 6px 12px;
            box-sizing: border-box;
            position: fixed;
            bottom: 0;
            .btn{
                width: 100%;
                height: 40px;
                background: var(--theme-color);
                border-radius: 20px;
                font-weight: 600;
                font-size: 16px;
                color: var(--theme-btn);
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>